// vue
import { useStore } from '@/store';

// models
import { GeoRecordModel } from '@/vue3/api/models';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGeoRecordModelService = () => {
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getAllGeoRecordModels = async () => {
        const res = await axios.get(`${apiUrl}/geo-record-model`);
        return res.data;
    };

    const getGeoRecordModel = async (id: number): Promise<GeoRecordModel> => {
        const res = await axios.get(`${apiUrl}/geo-record-model/${id}`);
        return res.data;
    };

    const createGeoRecordModel = async (
        geoRecordModel: GeoRecordModel,
    ): Promise<GeoRecordModel> => {
        const res = await axios.post(
            `${apiUrl}/geo-record-model`,
            geoRecordModel,
        );
        return res.data;
    };

    const updateGeoRecordModel = async (geoRecordModel: any) => {
        const res = await axios.put(
            `${apiUrl}/geo-record-model`,
            geoRecordModel,
        );
        return res.data;
    };

    const deleteGeoRecordModel = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/geo-record-model/${id}`);
        return res;
    };

    const createGeoRecordModelMesh = async (model: any): Promise<any> => {
        const res = await axios.postMultipart(
            `${apiUrl}/geo-record-model/mesh`,
            model,
        );
        return res.data;
    };

    return {
        getAllGeoRecordModels,
        getGeoRecordModel,
        createGeoRecordModel,
        updateGeoRecordModel,
        deleteGeoRecordModel,
        createGeoRecordModelMesh,
    };
};
